import React, { useState, useEffect } from 'react';

import { getval2Token, setVal2Token } from '../../../Login/Auth';
import { SingleText } from '../../Res/BaseInput';
import { getCaseStatus, getCaseStatusString } from '../../../../item/ItemRecruitmentContractorStatus';
import { ReqRecruitmentContractorCaseInfo, VIEW_ONBOARD_TO_RESERVE, VIEW_INVALID, JOB_STATUS_ONBOARD, VEW_CASEOWNER, VIEW_ONBOARDDATE, VIEW_CASESTATUS3 } from '../../../../item/ItemRecruitmentContractor';
import { ContentBox } from '../ContentBox';
import { SingleBigButton } from '../../Res/BaseButton';
import { ReviseCaseOwner } from './ReviseCaseOwner';
import { ReviseInvalid } from './ReviseInvalid';
import Swal from 'sweetalert2';
import { ReviseOnboardDate } from './ReviseOnboardDate';
import moment from 'moment';
import { ReviseOnBoard2Reserve } from './ReviseOnBoard2Reserve';



export function ReviseSOPCaseStatus3({ id, setIsLoading, isEdit = false }) {
  const [tokenId, setTokenId] = useState("")
  const [recruitmentContractorStatusItem, setRecruitmentContractorStatusItem] = useState(null)
  const [item, setItem] = useState(null)

  const [vw_status, set_vw_status] = useState(<></>)
  const [content, setContent] = useState(<></>)

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var item = getval2Token("ReviseSOPCaseStatus3", id)
      // console.log(item)
      var obj = getval2Token("recruitmentContractorStatusItem", id)
      // console.log(obj)
      setRecruitmentContractorStatusItem(obj)
      setTokenId(id)
      setItem(item)
      var mReqRecruitmentContractorCaseInfo = new ReqRecruitmentContractorCaseInfo({})
      mReqRecruitmentContractorCaseInfo.fromJson(item.caseInfo)
      set_vw_status(
        <>
          <SingleText title={"目前的 案件狀態"} val={item.caseContractorName + " " + getCaseStatusString(item, mReqRecruitmentContractorCaseInfo)} />
          <SingleText title={"當時的 預定上工日"} val={moment(mReqRecruitmentContractorCaseInfo.caseReserveDate).format('YYYY/MM/DD')} />
          <SingleText title={"目前的 案件管轄者"} val={item.caseOwnerName} />
        </>
      )
      //setContent(<ReviseView item={item} caseContractorName={caseContractorName} caseStatus={caseStatus} statusDate={statusDate} caseOwnerName={caseOwnerName} action={change} />)
    }
  }, [id])

  useEffect(() => {
    if (item !== null && tokenId !== null) {
      var view = getval2Token("view", tokenId)
      // console.log(view||VIEW_CASESTATUS1)
      change(view)
    }
  }, [item, tokenId])

  function change(val) {
    // console.log(item)
    switch (val) {
      case VIEW_ONBOARDDATE:
        setContent(<ReviseOnboardDate item={item} action={change} vw_status={vw_status} setIsLoading={setIsLoading} />)
        break;
      case VEW_CASEOWNER:
        setContent(<ReviseCaseOwner item={item} action={change} setIsLoading={setIsLoading} vw_status={vw_status} />)
        break;
      case VIEW_ONBOARD_TO_RESERVE:
        // console.log(typeof recruitmentContractorStatusItem.contractorJobStatus)
        // if (recruitmentContractorStatusItem.contractorJobStatus + "" === JOB_STATUS_ONBOARD) {
        //   Swal.fire({
        //     type: 'error',
        //     title: '外派員工已“上工”',
        //   })
        //   return
        // }
        setContent(<ReviseOnBoard2Reserve item={item} action={change} view={VIEW_CASESTATUS3} vw_status={vw_status} />)
        break;
      default:
        setContent(<ReviseView item={item} action={change} vw_status={vw_status} />)
        break;
    }
    setVal2Token('view', val, tokenId)
  }

  return (
    <>{content}</>
  )

}

function ReviseView({ item, action, vw_status }) {
  const [mItem, setItem] = useState({})
  useEffect(() => {
    if (item !== undefined && item !== mItem) {
      console.log(item)
      setItem(item)
    }
  }, [item])


  function toOnboardDate() {
    action(VIEW_ONBOARDDATE)
  }
  function toCaseOwner() {
    action(VEW_CASEOWNER)
  }
  function toReserve() {
    action(VIEW_ONBOARD_TO_RESERVE)
  }
  function toCaseStatusInvalid() {
    action(VIEW_INVALID)
  }

  var superTitle = "請選擇要進行哪一種修正方式"
  var title = ""
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          {vw_status}
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleBigButton name={"校正 “實際上工日”"} action={toOnboardDate} />

          <div className="col-md-9">
            <p className="col-md-12">
              提示：修正“實際上工日”，可能會影響加保日期，務必自行追蹤！</p>
          </div>
        </div>
      </div>
      <div className="hr-line-dashed"></div>

      <div className="row">
        <div className="col-md-12">
          <SingleBigButton name={"變更 “案件管轄者”"} action={toCaseOwner} size={3} />


          <div className="col-md-9">
            <p className="col-md-12">
              提示：如果原本的案件管轄者(招募員)離職了，請選用此修正方式，進行“派遣案件轉掛”。就能改變“直屬專員“</p>
          </div>
        </div>
      </div >

      <div className="hr-line-dashed"></div>

      <div className="row">
        <div className="col-md-12">
          <SingleBigButton name={"從“已上工” 改為 “預定中”"} action={toReserve} />

          <div className="col-md-9">
            <p className="col-md-12">
              提示：主要是復原案件在，招募員誤按“已報到”的情況。</p>
            <p className="col-md-12">
              注意：會影響待加保人員清單，務必自行追蹤！</p>
            <p className="col-md-12">
              特別提示：報到作業時，系統會自動將該外派員工的“其他預定中案件”變成“未報到”，請務必自行追蹤！</p>
          </div>
        </div>
      </div>
    </>

  return (
    <>
      <ContentBox superTitle={superTitle} title={title} titleSize={6} content={content} hasDrawer={false} />
    </>
  )
}

